// @landr/*-mfe are added at runtime so we use this to be able to mock it in the tests
// It also helps dynamic imports as UMD libraries require `import(...)` when the entry point is loaded

/* eslint-disable no-restricted-properties */
type BillingMfeType = typeof import('@landr/billing-mfe/app');

export const importBillingMfe = async () => {
    const url = System.resolve('@landr/billing-mfe/app');

    return import(
        /* webpackIgnore: true */ /* @vite-ignore */ url
    ) as Promise<BillingMfeType>;
};
